import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Input
} from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { Navigation } from '../../interfaces/navigation';
import { EventsService } from '../../services/events.service';
import { WordpressService } from '../../services/wordpress.service';
import * as $ from 'jquery';
import { PrevUrlService } from '../../services/prev-url.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() hideContent: boolean;
  navigation: Navigation;
  $body;
  $html;
  menuOpen: boolean;
  showBurger: boolean;
  reservationsOpen: boolean;
  boundKeyDown;
  previousUrl: string;
  noticeActive = true;

  constructor(
    private router: Router,
    private wp: WordpressService,
    private route: ActivatedRoute,
    private events: EventsService,
    private prevUrl: PrevUrlService,
    private location: Location
  ) {
    this.wp.getNavigation().subscribe(res => {
      this.navigation = res ? res.acf : null;
    });

    // Display reservations instantly
    if (window.location.pathname === '/reservations') {
      this.openReservations();
    }

    this.events.on('toggle:notice', (status) => {
      this.noticeActive = status || !this.noticeActive;
    });

    this.events.on('route:change', ({ path, intro }) => {
      this.previousUrl = path;
      // close nav on route changes
      this.closeOverlay();
      this.reservationsOpen = false;

      // if (path === '/reservations') {
      //   this.openReservations();
      // } else
      if (path !== '/') {
        this.showBurger = true;
      }
    });

    // Deep linking functionality
    if (window.location.pathname !== '/') {
      this.showBurger = true;
    }
  }

  openReservations() {
    this.hideContent = false;
    this.location.replaceState('/reservations');
    this.router.navigate(['/reservations']);
    this.reservationsOpen = true;
  }

  checkEnter(event) {
    if (event.keyCode === 13) {
      this.openReservations();
    }
  }

  closeReservations() {
    this.hideContent = true;
    this.prevUrl.updateUrl(this.previousUrl);
    this.reservationsOpen = false;
  }

  openOverlay() {
    this.hideContent = false;
    document.ontouchmove = function (e) {
      e.preventDefault();
    };

    this.menuOpen = true;
  }

  closeOverlay() {
    this.hideContent = true;
    document.ontouchmove = function (e) {
      return true;
    };

    this.menuOpen = false;
  }

  checkOverlay() {
    if (this.reservationsOpen) {
      // Don't remove 'overflow' class on body
      this.closeReservations();
    } else {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.openOverlay();
      } else {
        this.closeOverlay();
      }
    }
  }

  public onKeydownHandler(event: KeyboardEvent): void {
    const ESCAPE_KEYCODE = 27;
    if (event.keyCode === ESCAPE_KEYCODE) {
      if (this.reservationsOpen) {
        this.closeReservations();
      } else if (this.menuOpen) {
        this.closeOverlay();
      }
    }
  }

  toggleNotice() {
    this.events.broadcast('toggle:notice', !this.noticeActive);
  }

  ngOnInit() {
    // Close nav menu on escape key
    this.boundKeyDown = this.onKeydownHandler.bind(this);
    window.addEventListener('keydown', this.boundKeyDown);
  }

  ngAfterViewInit() {
    this.$body = $('body');
    this.$html = $('html');
  }

  ngOnDestroy() {
    // Close overlay && remove all event listeners
    if (this.reservationsOpen) {
      this.closeReservations();
    }
    if (this.menuOpen) {
      this.closeOverlay();
    }

    window.removeEventListener('keydown', this.boundKeyDown);
  }
}
